import React, { memo } from "react";
import HorseRow from "./HorseRow";
import {
  HOT_PICK_MIN_MARGIN,
} from "../../../../Utils/constants/constants";
// import LadbrokesLogo from "../../../../assests/LadbrokesLogo.png";

export function extractRaceNumber(raceName) {
  if (!raceName) return null;
  const match = raceName.match(/Race\s*(\d+)/i);
  return match ? match[1] : null;
}

function RaceCard({ race, raceId, expanded, onToggle, showHotPicks = false }) {
  const horses = race.results || [];
  const hasPredictions = horses.some((horse) => Number(horse.prediction_prob ?? 0) > 0);
  const firstRankHorse = horses.find((horse) => horse.rank === 1);
  const secondRankHorse = horses.find((horse) => horse.rank === 2);
  const leaderPredictionGap =
    Number(firstRankHorse?.prediction_prob ?? 0) -
    Number(secondRankHorse?.prediction_prob ?? 0);
  const showHotIconForLeader =
    showHotPicks &&
    hasPredictions &&
    Boolean(firstRankHorse && secondRankHorse) &&
    leaderPredictionGap > HOT_PICK_MIN_MARGIN;

  const handleToggleClick = () => {
    onToggle(raceId);
  };

  return (
    <div id={`race-card-${raceId}`} className="race-card bg-[var(--color-surface)] border border-[var(--color-border)] rounded-[var(--radius-md)] mb-3 overflow-hidden hover:border-[rgba(200,255,0,0.25)] transition-colors duration-200 ease-in-out">
      <button
        onClick={handleToggleClick}
        className="race-card-header w-full flex items-center justify-between md:p-4 p-3 gap-1 bg-transparent border-none text-left cursor-pointer hover:bg-[var(--color-bg)]"
      >
        <div className="race-name xl:text-base md:text-sm text-xs font-bold text-[var(--color-text)] uppercase tracking-[0.01em]">
          {race.race_name || `Race ${race.race_num}`}
        </div>
        <div
          className={`xl:text-base md:text-sm text-xs text-[var(--color-text)] transition-transform duration-200 ${
            expanded ? "rotate-180" : "rotate-0"
          }`}
        >
          ▾
        </div>
      </button>
      {expanded && horses.length > 0 && (
        <div className="race-horses">
          {!hasPredictions ? (
            <p className="flex items-center justify-center xl:text-base md:text-sm text-xs text-[var(--color-text)] text-center md:p-6 p-4 ">
              There are no predictions available for this race
            </p>
          ) : (
            <>
              {/* Column Header Row */}
              {/* <div className="grid grid-cols-[32px_40px_1fr_80px] gap-3 items-stretch pl-4 min-h-12 border-t border-[var(--color-border)] bg-black/15">
                <div />
                <div />
                <div />

                <div className="flex items-center justify-center text-center text-[10px] font-bold text-[var(--color-text-muted)] uppercase tracking-[0.05em] pl-[0.05em]">
                  Prediction
                </div>

                <div className="w-[74px] flex justify-center items-center ml-auto border-l border-[rgba(255,255,255,0.1)]">
                  <div className="w-8 h-8 rounded-full bg-[red] flex justify-center items-center overflow-hidden border border-[var(--color-text)] my-2.5">
                    <img
                      src={LadbrokesLogo}
                      alt="Ladbrokes"
                      className="w-full h-full object-contain p-1.5"
                    />
                  </div>
                </div>
              </div> */}
              
              {horses.map((h, idx) => {
                const dummyOdds = ["2.8", "4.5", "8.5", "14"];
                
                // Use horse.rank - 1 for index to ensure Rank 1 gets the lowest odds
                const rankIndex = h.rank ? h.rank - 1 : idx;
                const odd = dummyOdds[rankIndex] || "-";

                return (
                  <HorseRow
                    key={`${h.rank}-${h.horse_name}-${idx}`}
                    horse={h}
                    dummyOdd={odd}
                    showHotIcon={showHotIconForLeader && h.rank === 1}
                  />
                );
              })}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default memo(RaceCard);
